import './styles/Watchlist-Card.scss';

import { CircularProgress, Grid, Paper } from '@mui/material';

import { t } from 'i18next';

import { useWatchlistListQuery } from 'api/hooks/watchlist';
import { LinkButton } from 'app/components/LinkButton';
import { NoItems } from 'app/components/RichList/components/NoItems';
import { translations } from 'locales/i18n';

import { WatchlistCardItem } from './components/WatchlistCardItem';

export function WatchlistCard() {
  const { data: listResponse, isFetching } = useWatchlistListQuery({
    params: { take: 5 }
  });

  return (
    <Grid container className="watchlist-card" component={Paper} elevation={4}>
      <Grid container className="watchlist-card__heading">
        {t(translations.pages.home.watchlist.heading())}
      </Grid>
      <Grid container className="watchlist-card__body" direction={'column'}>
        {isFetching ? (
          <Grid minHeight={'12em'} alignContent={'center'}>
            <CircularProgress />
          </Grid>
        ) : listResponse && listResponse.data.length > 0 ? (
          <>
            {listResponse.data.map(watchListCardItem => {
              return <WatchlistCardItem key={watchListCardItem.id} {...watchListCardItem} />;
            })}
            <LinkButton
              href="/watchlist"
              linkText={t(translations.pages.home.watchlist.action())}
            />
          </>
        ) : (
          <>
            <NoItems message={t(translations.pages.home.watchlist.empty())} />
          </>
        )}
      </Grid>
    </Grid>
  );
}
